import React from 'react';
import ImageLoad from 'components/ImageLoad';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import PropTypes from 'prop-types';

const Items = (props) => {
    const item = props.item ? props.item : false;
    const {elementPos, positionGrid, nameGrid} = props;

    let imageResponsive = {
        840: item.image_mobile.url ? item.image_mobile.url : '',
        1440: item.imagen.url ? item.imagen.url : ''
    };
    
    const promotionClick = () => {
        const gtmData = {
            url_banner: item.url,
            id: item.imagen.url ? item.imagen.url : item.imagen.filename,
            name: item.imagen.url ? item.imagen.url : item.imagen.filename,
            creative: 'Vitrina Destacados ' + positionGrid + ' - ' + nameGrid,
            position: 'slot' + elementPos
        }

        TagManagerService.promotionsClick(gtmData);
    }

    
    return (
        <>{
            <div className="featured-showcase-item">
                <Link to={item.url} target={item.url_target} onClick={promotionClick}><ImageLoad className="" srcSet={imageResponsive} src={item.imagen.url ? item.imagen.url : ''}/></Link>
            </div>
        }</>
    )
}

Items.propTypes = {
    item: PropTypes.object,
    elementPos: PropTypes.number,
    positionGrid: PropTypes.number,
    nameGrid: PropTypes.string
}

export default Items;
